import { z } from "zod";
import type { IdentityApiSdk } from "@packsize/identity-api-sdk";

const _serverSettingsSchema = z.object({
	id: z.string(),
	tenantId: z.string(),
	unitOfMeasure: z.string(),
	loginExpirationInHours: z.number(),
	disablePasswordLogin: z.boolean(),
	requireEmailAsUsername: z.boolean(),
	requirePacksizeOkta: z.boolean(),
	failJobsForRequiredMachineGroup: z.boolean(),
	failJobsForRequiredCorrugate: z.boolean(),
	ssoDomain: z.string().nullish(),
});

export type ServerSettings = z.infer<typeof _serverSettingsSchema>;

export const getServerSettings = async (client: IdentityApiSdk): Promise<ServerSettings | undefined> => {
	const response = await client.getSettings();

	if (!response.data) {
		return undefined;
	}

	// return serverSettingsSchema.parse(response.data); test parse
	return response.data as ServerSettings;
};

export const updateServerSettings = async (client: IdentityApiSdk, settings: ServerSettings): Promise<void> => {
	// return serverSettingsSchema.parse(settings); test parse
	await client.updateSettings(settings);
};
